export enum AppType {
  PORTAL = 'portal',
  ADMIN = 'admin',
}
